import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Footer from "../components/Footer";
import NewsHub from "../components/NewsHub";

const NewsPage = () => <Layout pageTitle="HiTech | Tin tức"><Helmet><meta name="description" content="Tin tức, kiến thức Solar, quản trị EPC, HITECH TALENT và công nghệ từ HITECH." /><meta property="og:title" content="Tin tức & Góc nhìn | HITECH" /><meta property="og:description" content="Cập nhật kiến thức, xu hướng và hoạt động mới nhất từ HITECH." /></Helmet><NavOne /><NewsHub /><Footer /></Layout>;

export default NewsPage;
